module.exports = __webpack_public_path__ + "static/media/ShardMeetingRoom1.5eb81941.jpg";